import axios from "axios";

const CLOUDINARY_URL = "https://api.cloudinary.com/v1_1/dvghrzmnp/image/upload";
const UPLOAD_PRESET = "umadesign_unsigned";

export const uploadToCloudinary = async (file) => {
  if (!file) return null;
  const formData = new FormData();
  formData.append("file", file);
  formData.append("upload_preset", UPLOAD_PRESET);

  try {
    const res = await axios.post(CLOUDINARY_URL, formData);
    return res.data.secure_url;
  } catch (err) {
    console.error("Cloudinary Upload Error:", err);
    return null;
  }
};